import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsBikeNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g clipPath="url(#sports_bike_normal_large_svg__clip0_138_85)">
        <path
          d="M10 39a10.015 10.015 0 009.95-9.01h4.98l6.37-12.85 1.15 2.19.53 1.02h.01l.92 1.78L38.03 30h2.26l-4.54-8.67A7.61 7.61 0 0138 21a8.023 8.023 0 11-5.69 2.39l-.97-1.85A10 10 0 1038 19a9.679 9.679 0 00-3.2.53l-2.4-4.6v-.01l-.48-.92h-.01l-1.57-3h4.64a.942.942 0 01.8.38 1.036 1.036 0 01.08 1.15.97.97 0 01-.86.47h-1.35l1.05 2h.3a2.981 2.981 0 002.44-4.73A2.917 2.917 0 0034.98 9h-7.94l2.62 5H17.444l-2.126-4h3.7L17.95 8H8.99l1.06 2h3l2.377 4.47-2.647 4.93A9.78 9.78 0 0010 19a10 10 0 000 20zm19.64-23l-5.375 10.831L18.507 16H29.64zM13.7 21.92l.95-1.77.44-.81 1.478-2.727 6.048 11.377H19.95a10.057 10.057 0 00-3.66-6.76l-.97 1.8a8.007 8.007 0 012.62 4.96h-7.51l1.23-2.27v-.01l2.04-3.79zM10 21a7.73 7.73 0 011.81.21l-3.64 6.76 1.05 2.02h8.72A8 8 0 1110 21z"
          fill=""
        />
      </g>
      <defs>
        <clipPath id="sports_bike_normal_large_svg__clip0_138_85">
          <path fill="#fff" d="M0 0h48v48H0z" />
        </clipPath>
      </defs>
    </svg>
  )
);
SvgSportsBikeNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsBikeNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsBikeNormalLarge;
